export const formateDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${(`0${month}`).slice(-2)}-${(`0${day}`).slice(-2)}`;
};
